import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { initTheme } from './theme/theme';
import { registerServiceWorker } from './app/pwa';
import './theme/tokens.css';
import './theme/base.css';
import './theme/board.css';
import './theme/pages.css';

initTheme();
registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
